import { DialogProps, useDialog } from '@/composables/useDialog';
import { ObjectDirective, DirectiveBinding } from 'vue';

export type DialogValue = string | [string, Record<string, any>, Record<string, any>?];

const dialogDirective: ObjectDirective = {
	bind(el: HTMLElement, binding: DirectiveBinding<DialogValue>) {
		const { open } = useDialog();
		const type = binding.arg;
		el.addEventListener('click', () => {
			const [id, props, dialogOptions = {}] = Array.isArray(binding.value)
				? [binding.value[0], binding.value[1], binding.value[2] as DialogProps | undefined]
				: [binding.value, null];

			if (binding.arg && binding.arg === 'video') {
				return open('video-player', {
					id,
					autoplay: binding.modifiers.autoplay,
					...props
				}, {
					centered: true,
					fullscreen: false,
					...dialogOptions
				});
			}

			return open(id, props, dialogOptions);
		});
	}
};

export default dialogDirective;
